var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.638 13.426-.66 3.517 6.265.88-.44 1.648-6.154-.879c-.44 1.43-.66 2.969-1.21 4.287-.55 1.54-1.099 3.078-1.758 4.506-.88 1.868-2.418 3.187-4.506 3.517-1.209.22-2.528.11-3.517-.66-.33-.22-.66-.659-.66-.989 0-.438.22-.988.55-1.207.22-.11.769 0 1.098.11.33.33.66.769.88 1.208.66.88 1.538.99 2.417.331.99-.878 1.54-2.087 1.869-3.296.66-2.637 1.318-5.165 1.868-7.803v-.438l-5.825-.88.22-1.648 6.045.88.769-3.408-6.263-.989.22-1.758 6.483.878c.22-.66.33-1.209.55-1.758.55-1.978 1.1-3.957 2.418-5.715 1.319-1.758 2.857-2.857 5.165-2.747.99 0 1.978.33 2.638 1.099.11.11.33.33.33.55 0 .439 0 .988-.33 1.318-.44.33-.989.22-1.428-.22-.33-.33-.55-.66-.88-.99-.659-.878-1.648-.988-2.417-.219a7.04 7.04 0 0 0-1.429 2.088c-.77 2.308-1.319 4.726-2.088 7.144l6.045.879-.44 1.648-5.825-.879z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFil);
export default __webpack_public_path__ + "static/media/FIL.4cfffc5bc55356c3864f28c60c853d51.svg";
export { ForwardRef as ReactComponent };